import React from "react";

const Footer = () => {
    return (
        <>
            <footer id="footer-ivdp">
                <div id="conteiner-rdd-copyright">
                    <img src="/imgs/rddLogo.svg" id="logo-rdd" alt="RDD+" />
                    <p id="footer-copyright">
                        Copyright © {new Date().getFullYear()} RDD+. Todos os direitos reservados.
                    </p>
                </div>
                <img src="/imgs/Compete2020logo_40px.png" id="logo-Compete2020" alt="Compete2020" />
            </footer>
        </>
    );
};

export default Footer;
